exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".aHLPi{padding-top:0;padding-left:20px;padding-right:20px;font-family:Roboto,sans-serif}._3vmN0{margin:0 50px;padding:0 0 40px}._38iXq{height:200px}._38iXq h1{color:#fff;margin:0 50px;padding:30px 15px;font-family:Roboto\\, Thin,sans-serif}._38iXq h1 small{font-family:Roboto\\, Medium,sans-serif;font-size:20px}._1-bb1{font-size:48px}._3_o99{font-family:Roboto\\, Medium,sans-serif;position:inherit;color:#e4002b;cursor:pointer;outline:none;font-size:18px;clear:left;right:inherit;text-align:inherit;margin-top:20px;margin-bottom:0}._3_o99:focus,._3_o99:hover{color:#e4002b;text-decoration:none}._28MMp{margin-top:22px}@media (max-width:770px){._3wW99{margin-top:-70px}._3_o99{position:static}}", ""]);

// exports
exports.locals = {
	"root": "aHLPi",
	"container": "_3vmN0",
	"imageBanner": "_38iXq",
	"eConsulta": "_1-bb1",
	"linkModalBienvenida": "_3_o99",
	"eConsultaDiv": "_28MMp",
	"mtMinus": "_3wW99"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/routes/telemedicina/TelemedicinaPageUserLoggedIn.css
// module id = 1249
// module chunks = 0 1